import api from './api';
import { API_CLIENT_DOMAIN } from '../constants';
import { handleError } from '../errorHandler';

export const uninstallWebApp = (onSuccess: Function, onFailure: Function) => {
  api
    .delete(API_CLIENT_DOMAIN + '/web-app')
    .then((response) => onSuccess(response.data))
    .catch((error) => handleError(error, onFailure));
};
